import type { Photo } from 'app/types/commonTypes.type';
import imageUtils from 'app/shared/utils/imageUtils';

type ListingLike = {
  largePhotos?: Array<Photo>;
  photos?: Array<Photo>;
  floorplans?: Array<{ largePhotos?: Array<Photo>; modelId?: string }>;
  previewPhoto?: Photo & { noPhoto?: boolean };
};

function getFloorplanPhotos(listing: ListingLike): Array<Photo> {
  const floorplanPhotos: Array<Photo> = [];

  for (const fp of listing.floorplans ?? []) {
    for (const photo of fp.largePhotos ?? []) {
      if (photo.url) {
        floorplanPhotos.push(photo);
      }
    }
  }

  return floorplanPhotos;
}

export function getHaloPhotos(listing: ListingLike | null | undefined): Array<Photo> {
  if (!listing) {
    return imageUtils.noImageFound();
  }

  let photos: Array<Photo> = [];

  if (listing.largePhotos?.length) {
    photos = photos.concat(listing.largePhotos);
  } else if (listing.photos?.length) {
    photos = photos.concat(listing.photos);
  }

  const floorplanPhotos = getFloorplanPhotos(listing);
  const seenUrls = new Set(photos.map((p) => p.url));
  for (const photo of floorplanPhotos) {
    if (!seenUrls.has(photo.url)) {
      seenUrls.add(photo.url);
      photos.push(photo);
    }
  }

  if (photos[0]?.url) {
    return photos;
  }

  if (listing.previewPhoto?.url && !listing.previewPhoto.noPhoto) {
    const previewPhoto = { ...listing.previewPhoto };
    if (previewPhoto.url.includes('thumb')) {
      previewPhoto.url = previewPhoto.url.replace(/thumb/, 'large');
    } else if (previewPhoto.url.includes('medium')) {
      previewPhoto.url = previewPhoto.url.replace(/medium/, 'large').replaceAll('500', '1200');
    }
    return [previewPhoto];
  }

  return imageUtils.noImageFound();
}
